import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <span className="icon fa-microphone"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Small Talks</h1>
                <p>Tell a story. Share an idea. Talk to us</p>
                <p>Local home-grown knowledge. Come share what inspires you.</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('intro')}}>About</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('work')}}>Events</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>Archive</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
